import script from "./Pagination.vue?vue&type=script&setup=true&lang=ts"
export * from "./Pagination.vue?vue&type=script&setup=true&lang=ts"

import "./Pagination.vue?vue&type=style&index=0&id=0f06eb1e&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0f06eb1e"]])

export default __exports__